export const getIsRefreshTimerActive = (state) => state.mrdMonitoring.isRefreshTimerActive;
